import { render, staticRenderFns } from "./holiday-edit-modal.vue?vue&type=template&id=54a87835"
import script from "./holiday-edit-modal.vue?vue&type=script&lang=js"
export * from "./holiday-edit-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports